module.exports = __webpack_public_path__ + "static/media/med_loader_xor.f8a86a96.gif";